import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterControls = ({
  dateRange,
  setDateRange,
  selectedStage,
  setSelectedStage,
  selectedRep,
  setSelectedRep
}) => {
  const dateRangeOptions = [
    { value: 'weekly', label: 'Last 7 Days' },
    { value: 'monthly', label: 'Last 30 Days' },
    { value: 'quarterly', label: 'This Quarter' },
    { value: 'yearly', label: 'This Year' }
  ];

  const stageOptions = [
    { value: 'all', label: 'All Stages' },
    { value: 'lead', label: 'Lead' },
    { value: 'qualified', label: 'Qualified' },
    { value: 'proposal', label: 'Proposal' },
    { value: 'negotiation', label: 'Negotiation' },
    { value: 'closed', label: 'Closed' }
  ];

  const repOptions = [
    { value: 'all', label: 'All Reps' },
    { value: 'priya', label: 'Priya Sharma' },
    { value: 'rahul', label: 'Rahul Verma' },
    { value: 'anjali', label: 'Anjali Patel' },
    { value: 'vikram', label: 'Vikram Singh' },
    { value: 'neha', label: 'Neha Gupta' },
    { value: 'arjun', label: 'Arjun Reddy' }
  ];

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 shadow-elevation-2 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">Filters</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Date Range Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Date Range
          </label>
          <select
            value={dateRange}
            onChange={(e) => setDateRange(e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary transition-all"
          >
            {dateRangeOptions?.map((option) => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Deal Stage Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Deal Stage
          </label>
          <select
            value={selectedStage}
            onChange={(e) => setSelectedStage(e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary transition-all"
          >
            {stageOptions?.map((option) => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Sales Rep Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Sales Representative
          </label>
          <select
            value={selectedRep}
            onChange={(e) => setSelectedRep(e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary transition-all"
          >
            {repOptions?.map((option) => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;